import React from 'react';
import MultiSeriesRadarChartLib from '../../charts/MultiSeriesRadarChartLib';

import './MultiSeriesRadarChart.css';

class MultiSeriesRadarChart extends React.Component {

    componentDidMount() {
        const config = {
            w: this.props.style.width,
            h: this.props.style.height,
            maxValue: 3,
            levels: 5,
            ExtraWidthX: 10,
            ExtraWidthY: 10
        }


        MultiSeriesRadarChartLib.draw(`#${this.props.id}`, this.props.series, config);
    }

    render() {
        return (
            <div id={this.props.id}></div>
        );
    }
}

MultiSeriesRadarChart.defaultProps = {
    id: 0,
    style: {
        width: 275,
        height: 150
    },
    data: []
};

export default MultiSeriesRadarChart;


// WEBPACK FOOTER //
// ./src/components/charts/MultiSeriesRadarChart.js